const complaintApis = {};
const files = require.context('./modules', false, /\.js$/);
files.keys().forEach((key) => {
  const name = key.substring(key.lastIndexOf('/') + 1, key.length - 3);
  complaintApis[name] = files(key).default;
});
export default complaintApis;
